import(/* webpackMode: "eager" */ "/vercel/path0/app/[locale]/educacion/metabolismo/page.jsx");
